import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {ReferralAgreement} from "../../entities/Agency.ts";

export class GetAgencyReferralsUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    execute(agencyId: string): Promise<ReferralAgreement[]> {
        return this.agencyRepository.getReferrals(agencyId)
    }
}
